// extracted by mini-css-extract-plugin
module.exports = {"inputField":"InputArea_inputField__LFsB1","inputError":"InputArea_inputError___nk8-","errorInfo":"InputArea_errorInfo__1ZzPP"};